
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import { getHrefLangs } from 'src/core/utils/href-langs';
import Legal, { PageProps } from 'src/components/legal';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  data: PageProps,
  slug: string
};

/**
 * `SgiPolicy` page.
 */

const SgiPolicy = (props: Props): ReactElement => (
  <Legal
    {...props}
    hrefLangs={getHrefLangs(props?.data?.translations, 'aboutUsSgiPolicy')}
    routeName={'aboutUsSgiPolicy'}
  />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  const slug = getApiPageSlugByLocale('aboutUsSgiPolicy', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `SgiPolicy` page.
 */

export default SgiPolicy;
